import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import 'moment/locale/ko'

// components
import { Empty, ReviewItem, StarRating } from './components'
import { CalendarModal, DeleteModal, Period, Selector } from '../../components'
import QuarterlySelectionModal from '../../components/modal/QuarterlySelectionModal'

// globals
import * as constants from '../../globals/constants'
import * as TYPE from '../../globals/type'

// utils
import { useAxios } from '../../utils/useAxios'
import { checkEmptyObject } from '../../utils/checkEmptyObject'
import { getFormatDate } from '../../utils/getFormatDate'

// styles
import colors from '../../styles/colors'

//휴무일설정 false
const daysOffSetting = false

const REVIEW_PERIOD_ITEM = [
  { name: '오늘', action: () => console.log('$$ 오늘') },
  { name: '이번주', action: () => console.log('$$ 이번주') },
  { name: '30일', action: () => console.log('$$ 30일') },
  { name: '분기', action: () => console.log('$$ 분기') },
  { name: '날짜', action: () => console.log('$$ 날짜') },
]

const ReviewList = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  const { fetchData, loading, data, error } = useAxios()
  // 전체(0)
  const [showReview, setShowReview] = useState(0)

  const [starPoint, setStarPoint] = useState({
    avg: 0,
    arr: [0, 0, 0, 0, 0],
    len: 0,
  })
  const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'))
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'))

  const [selectedIndex, setSelectedIndex] = useState(0)
  const [adminOnly, setAdminOnly] = useState(null) // 미답변 params값

  // modal
  const [isQuarterVisibleModal, setIsQuarterVisibleModal] = useState(false)
  const [isCalVisibleModal, setIsCalVisibleModal] = useState(false)
  const [isDeleteVisibleModal, setIsDeleteVisibleModal] = useState(false)

  // delete item
  const [deleteItem, setDeleteItem] = useState(null)

  // calendar
  const [rangeDates, setRangeDates] = useState([])
  const defaultSelected = {
    to: '',
    from: '',
  }
  const [range, setRange] = useState(defaultSelected)
  const [isChangeCal, setIsChangeCal] = useState(false)

  const [reviewItem, setReviewItem] = useState(null)
  const [filterItem, setFilterItem] = useState(null)

  // 페이지네이션
  const [page, setPage] = useState(1)

  // API: 리뷰 조회
  const getReviewList = (start, end, adminOnly) => {
    const params = {
      startDate: start,
      endDate: end,
      startNo: 10 * (page - 1) + 1,
      endNo: 10 * page,
      adminOnly: adminOnly,
    }

    fetchData(
      constants.API.REVIEW,
      'GET', // method
      null, // body
      params, // params
      null, // header
    )
  }

  const selectDeleteComment = (item) => {
    setDeleteItem(item)
    setIsDeleteVisibleModal(true)
  }

  // API : 리뷰 댓글 삭제(POST)
  const onDeleteComment = (item) => {
    const body = {
      odOrderId: item.odOrderId,
      feedbackId: item.feedbackId,
      comment: '삭제된 댓글입니다.',
    }

    fetchData(
      constants.API.REVIEW, // url
      'POST', // method
      body, // body
      null, // params
      null, // header
    )
  }

  // API : 리뷰 댓글 등록(POST)
  const onAddComment = (item, comment) => {
    if (comment.length < 10) {
      return alert('최소 10자 이상 입력해주세요.')
    } else {
      const body = {
        odOrderId: item.odOrderId,
        feedbackId: item.feedbackId,
        comment,
      }

      fetchData(
        constants.API.REVIEW, // url
        'POST', // method
        body, // body
        null, // params
        null, // header
      )
    }
  }

  const handleAnswerTab = (flag) => {
    console.log('flag', flag)
    setShowReview(flag)
    if (flag === 1) {
      setPage(1)
      setAdminOnly('N') //미답변
    } else {
      setAdminOnly(null)
    }
  }

  const handleSetModal = () => {
    if (selectedIndex === 3) {
      setIsQuarterVisibleModal(true)
    } else {
      // 디폴트 날짜 세팅
      setRange({
        from: new Date(startDate),
        to: new Date(endDate),
      })

      setIsCalVisibleModal(true)
    }
  }

  const selectRangeDate = () => {
    // 아무것도 선택 안한 경우
    if (!range?.to && !range?.from) return setIsCalVisibleModal(false)
    // 하나만 선택
    else if (!range?.to && range?.from) {
      setStartDate(range.from)
      setEndDate(range.from)
    }
    // 모두 선택
    else if (getFormatDate(range.from) && getFormatDate(range.to)) {
      setStartDate(range.from)
      setEndDate(range.to)
      setSelectedIndex(4)
      setIsChangeCal(true)
    }

    setIsCalVisibleModal(false)
  }

  const selectQuarter = (start, end) => {
    setIsQuarterVisibleModal(false)

    if (getFormatDate(start) && getFormatDate(end)) {
      setStartDate(start)
      setEndDate(end)
    }
  }

  const handleDateTab = (flag) => {
    setSelectedIndex(flag)

    if (flag !== 3) {
      setIsChangeCal(false)
      setRange(defaultSelected)
    }
  }

  const handlePeriodItem = (flag) => {
    switch (flag) {
      case 0:
      case 1:
      case 2:
        setSelectedIndex(flag)
        break

      case 3:
        setIsQuarterVisibleModal(true)
        setSelectedIndex(flag)
        break

      case 4:
        setIsChangeCal(false)
        setIsCalVisibleModal(true)
        setSelectedIndex(flag)
        break

      default:
        break
    }
    // if (flag === selectedIndex) return
    // else {
    //   if (flag === 4) {
    //     setIsChangeCal(false)
    //   }

    //   setSelectedIndex(flag)
    // }
  }

  // request fetch
  useEffect(() => {
    if (startDate) {
      getReviewList(
        moment(startDate).format('YYYY-MM-DD'),
        moment(endDate ?? startDate).format('YYYY-MM-DD'),
        adminOnly,
      )
    }
  }, [startDate, endDate, page, adminOnly])

  // success fetch
  useEffect(() => {
    if (data?.responseCode === TYPE.API_RESPONSE.SUCCESS) {
      let result = data?.responseData ?? null

      // 조회
      if (result?.reviewList) {
        setReviewItem(result)

        setFilterItem(result.reviewList)

        setFilterItem({
          ...filterItem,
          reviewList: result.reviewList,
        })

        setStarPoint({
          avg: result.avgScore,
          arr: [
            result.avgScoreCount5,
            result.avgScoreCount4,
            result.avgScoreCount3,
            result.avgScoreCount2,
            result.avgScoreCount1,
          ],
          len: result.reviewListCount,
        })
      }

      // 등록/삭제
      else {
        getReviewList(
          moment(startDate).format('YYYY-MM-DD'),
          moment(endDate ?? startDate).format('YYYY-MM-DD'),
        )
      }
    }
  }, [data])

  useEffect(() => {
    if (selectedIndex === 4 && !isChangeCal) {
      // 디폴트 날짜 세팅
      setRange({
        from: new Date(startDate),
        to: new Date(endDate),
      })

      // setIsCalVisibleModal(true)
    }
    // if (selectedIndex === 3) {
    //   setIsQuarterVisibleModal(true)
    // } else if (selectedIndex === 4 && !isChangeCal) {
    //   // 디폴트 날짜 세팅
    //   setRange({
    //     from: new Date(startDate),
    //     to: new Date(endDate),
    //   })

    //   setIsCalVisibleModal(true)
    // }
  }, [selectedIndex])

  return (
    <>
      <Container>
        <PeriodInfoWrapper>
          <Period
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            dateText={'1년'}
            periodItem={REVIEW_PERIOD_ITEM}
            selectedIndex={selectedIndex}
            handleDateTab={handleDateTab}
            setSelectedIndex={handlePeriodItem}
            handleSetModal={handleSetModal}
            setIsQuarterVisibleModal={setIsQuarterVisibleModal}
          />
          <InfoWrapper>
            * 해피오더 고객 리뷰는 최근 1년 내 작성 내역만 노출됩니다.
          </InfoWrapper>
        </PeriodInfoWrapper>
        {!reviewItem ||
        reviewItem?.reviewListCount === 0 ||
        data.responseCode === TYPE.API_RESPONSE.NOT_DATA ? (
          <Wrapper>
            <Empty pointTxt={'등록된 리뷰'} txt={'가 없습니다.'} />
          </Wrapper>
        ) : (
          <>
            <Wrapper>
              <StarRating starPoint={starPoint} />
              <Selector
                isLeftAlign={true}
                leftText={'전체'}
                rightText={'미답변'}
                selectedIdx={showReview}
                handleTab={handleAnswerTab}
              />
            </Wrapper>

            <ReviewItem
              filterItem={filterItem.reviewList}
              total={reviewItem?.reviewListCount ?? 0}
              page={page}
              setPage={setPage}
              onDeleteComment={selectDeleteComment}
              onAddComment={onAddComment}
            />
          </>
        )}
      </Container>
      <CalendarModal
        title={'날짜'}
        show={isCalVisibleModal}
        handleClose={() => {
          setIsCalVisibleModal(false)
        }}
        handleSubmit={selectRangeDate}
        setStartDate={setStartDate}
        startDate={startDate}
        setEndDate={setEndDate}
        endDate={endDate}
        range={range}
        setRange={setRange}
        rangeDates={rangeDates}
        setRangeDates={setRangeDates}
        daysOffSetting={daysOffSetting}
      />

      <QuarterlySelectionModal
        show={isQuarterVisibleModal}
        handleClose={() => {
          setIsQuarterVisibleModal(false)
        }}
        handleSubmit={selectQuarter}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        endDate={endDate}
        title={'분기'}
      />

      <DeleteModal
        show={isDeleteVisibleModal}
        message={'이 댓글을 삭제하시겠습니까?'}
        buttons={['취소', '삭제']}
        handleClose={() => {
          setDeleteItem(null)
          setIsDeleteVisibleModal(false)
        }}
        handleSubmit={() => {
          onDeleteComment(deleteItem)
          setIsDeleteVisibleModal(false)
        }}
      />
    </>
  )
}

export default ReviewList

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  position: relative;
`

const PeriodInfoWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${(props) => props.theme.mobile} {
    padding: 0 20px;
  }
`

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${(props) => props.theme.mobile} {
    padding: 0 20px;
  }
`

const InfoWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 768px;
  min-width: 320px;
  display: flex;
  margin: 43px 0 15px;
  font-size: 14px;
  color: ${colors.G4};

  @media ${(props) => props.theme.mobile} {
    font-size: 12px;
    margin: 33px 0 14px;
  }
`
